import { Pipe, PipeTransform } from '@angular/core';
import { IAddressData } from '@df/session/api/address-book/address';
@Pipe({
    name: 'addressName',
    standalone: true
})
export class AddressNamePipe implements PipeTransform {
    transform(addressData: IAddressData) {
        if (addressData) {
            const name = [addressData.prefix, addressData.firstname, addressData.lastname].filter(i => !!i).join(' ');
            return addressData.nickname ? `${name} (${addressData.nickname})` : name;
        }
    }
}
